import React from 'react';
import PropTypes from 'prop-types';
import ResourceItem from 'components/ResourceItem';

function AllResourcesListSet({ item }) {
  switch (item.type) {
    case 'Videos':
      return (
        <ResourceItem
          key={item.slug}
          item={item}
          type="video"
          route="/videos"
        />
      );
    case 'Apps':
      return (
        <ResourceItem key={item.slug} item={item} type="app" route="/apps" />
      );
    case 'Podcasts':
      return (
        <ResourceItem
          key={item.slug}
          item={item}
          type="podcast"
          route="/podcasts"
        />
      );
    case 'Books':
      return (
        <ResourceItem key={item.slug} item={item} type="book" route="/books" />
      );
    case 'Articles':
    case 'News':
      return (
        <ResourceItem
          key={item.slug}
          item={item}
          type="article"
          route="/articles"
        />
      );
    case 'Online Programs':
      return (
        <ResourceItem
          key={item.slug}
          item={item}
          type="program"
          route="/programs"
        />
      );
    default:
      return null;
  }
}

AllResourcesListSet.propTypes = {
  item: PropTypes.object,
};

export default AllResourcesListSet;
